function gmaps() {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  // Map custom styles.
  const myStyles = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c9c9c9"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ];

  // Map default options.
  const defaultOptions = {
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    styles: myStyles,
    restriction: {
      latLngBounds: {
        east: 179.999,
        north: 89.999,
        south: -89.999,
        west: -179.999
      },
      strictBounds: true
    },
    minZoom: 2,
    maxZoom: 18,
  };

  // Map markers array.
  let markers = [];

  // Map object.
  var map;

  /**
   * Init reseller map.
   *
   * @param boolean centerOnSiteCountry Center map on website country (ex. mantion.fr -> fr -> France).
   * @param boolean allResellers Default `false` Fetch all reseller?
   */
  function initMap(centerOnSiteCountry, allResellers = false) {
    if (centerOnSiteCountry) {
      $.getJSON(directory_uri.stylesheet_directory_uri + '/assets/js/countries.json', function (countries) {
        const lang_code = current_lang.toUpperCase() === 'EN' ? 'GB' : current_lang.toUpperCase();

        // Always center on USA.
        const country = countries[countries.findIndex(function (item) {
          return item.short_name === 'US';
        })];

        // Create map.
        map = new google.maps.Map(document.getElementById("map"), {
          ...defaultOptions,
          ...{
            center: new google.maps.LatLng(country.center_lat, country.center_lng),
          }
        });

        // Fetch resellers.
        let params = {};

        if (allResellers) {
          params.search = '';
          params.type = 'no-search';
        }
        else {
          params.country = country.long_name;
          params.type = "country";
        }

        fetchAndDisplayResellers(params, null, false, function(response) {
          findPlace({
            "query": country.long_name,
            "fields": ["place_id", "geometry"],
          }, false);
        });
      });
    }
    else {
      map = new google.maps.Map(document.getElementById("map"), {
        ...defaultOptions,
        ...{
          zoom: 11,
        },
      });
    }
  }

  function cleanMarkers() {
    for (var i in markers) {
      markers[i].setMap(null);
    }

    markers = [];
  }

  /**
   * Fetch and add resellers on map.
   *
   * @param object params Search params.
   * @param object userPosition Default `null`. User's position.
   * @param boolean centerOnFirstReseller Default `true`. If no `userPosition` is given, center map on first result?
   * @param function cb Default `null`. Callback after everything is done, takes 1 param which is the ajax response.
   */
  function fetchAndDisplayResellers(params, userPosition = null, centerOnFirstReseller = true, cb = null) {
    // Start loading animation.
    $('.infinite-loader').addClass('active');

    cleanMarkers();

    $.ajax({
      url: baseUrl + '/wp-json/mantion/v1/resellers-search/',
      method: 'GET',
      beforeSend: function(xhr) {
        //xhr.setRequestHeader("X-WP-Nonce", window.mtn.api.nonce);
      },
      data: params,
      success: function(response) {
        // Reset resellers list.
        $('#results ul').html('');

        // If resellers, fill the map.
        if (response.length > 0) {
          $('.message').hide();
          $('.result-container').show();
          $('.count-results').show();

          const infoWindow = new google.maps.InfoWindow({
            content: '',
          });

          // If on product page, filters reseller if they have product in stock.
          if (typeof resellersWithProduct !== 'undefined' && Array.isArray(resellersWithProduct)) {
            var _response = [];

            for (i in response) {
              if (resellersWithProduct.includes(response[i].divalto_tiers)) {
                _response.push(response[i]);
              }
            }

            response = _response;
          }

          for (var i in response) {
            let html = '<div class="reseller-info ' + (response[i].is_mantion_relay == 1 ? 'reseller-info--relay-mantion' : '') + '">';

            if (response[i].logo) {
              html += '<div class="logo"><img src="' + response[i].logo + '"></div>';
            }
            else {
              html += '<div class="logo"><img src="/wp-content/themes/mantion/assets/img/reseller-placeholder.svg"></div>';
            }

            html += '<h3 data-latitude="'+response[i].latitude+'" data-longitude="'+response[i].longitude+'">' + response[i].title  + '</h3>'+
            (response[i].name_contact ? response[i].name_contact + '<p></p>' : '') +
            '<p>' + response[i].street + '</p><p>' + (response[i].loc ? response[i].loc + '</p></p>' : '') + response[i].zip_code + ' '+ response[i].city +'</p>';

            if (response[i].phone) {
              html += '<p>Tel : ' + response[i].phone + '</p>';
            }

            if (response[i].fax) {
              html += '<p>Fax : ' + response[i].fax + '</p>';
            }

            if (response[i].website && response[i].website !== '.') {
              let vendorUrl;

              if (response[i].website.indexOf("http") < 0) {
                vendorUrl = "http://" + response[i].website;
              }
              else {
                vendorUrl = response[i].website
              }
              if (vendorUrl) {
                  html += '<p>Site : ' + '<a target="_blank" href="' + vendorUrl + '">' + response[i].website + '</a></p>';
              }
            }

            if (response[i].email && response[i].email !== '.') {
              html += '<a class="mail-link" href="mailto:'+ response[i].email + '">' + response[i].email + '</a>';
            }

            if (response[i].is_mantion_relay == 1) {
              html += '<div class="mantion-relay-top"><img title="' + mantion.resellers.mantion_relay + '" src="/wp-content/themes/mantion/assets/img/RETRAIT-MANTION.svg"></div>'
              html += '<div class="mantion-relay-bottom"><img title="' + mantion.resellers.mantion_relay + '" src="/wp-content/themes/mantion/assets/img/RETRAIT-MANTION.svg">' + mantion.resellers.mantion_relay + '</div>'
            }

            html += '</div>';

            // If a position is given, add a distance text below the reseller infos.
            if (userPosition) {
              html += '<p class="distance"><img src="' + directory_uri.stylesheet_directory_uri + '/assets/img/BOUSSOLE_KM.svg' + '" alt=""/>' + Math.round(response[i].distance*100)/100 + ' km</p>';
            }

            // Add button to select reseller on checkout page.
            if ($('body').hasClass('woocommerce-checkout')) {
              html += "<button data-id=" + response[i].post_id + " class='select-revendeur button'>" + mantion.resellers.choose_this_reseller + "</button>";
            }

            // Append to results node.
            $('#results ul').append('<li class="reseller-ct" id="reseller-' + response[i].post_id + '">' + html + '</li>');
            $('#reseller-' + response[i].post_id).data('reseller', response[i]);

            // Create map marker.
            const marker = new google.maps.Marker({
              position: new google.maps.LatLng(response[i].latitude, response[i].longitude),
              title: response[i].title,
              map: map,
              icon: {
                url: directory_uri.stylesheet_directory_uri + '/assets/img/CURSEUR_REVENDEUR.png',
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 50)
              },
              reseller_id: response[i].post_id,
            });

            // Handle click on map marker.
            google.maps.event.addListener(marker, 'click', (function(marker, i) {
              return function() {
                infoWindow.setContent('<div class="reseller-ct info-window">'+html+'</div>');
                infoWindow.open(map, marker);
              }
            })(marker, i));

            // Add marker to markers list.
            markers.push(marker);
          }

          // Set map zoom level depending on wether we are focusing on a single country or not.
          map.setZoom(params.type == 'country' ? 6 : 11);

          // Move map to given position or first reseller's position.
          if (userPosition) {
            map.panTo(new google.maps.LatLng(userPosition.coords.latitude, userPosition.coords.longitude));
          }
          else if (centerOnFirstReseller && response.length > 0) {
            map.panTo(new google.maps.LatLng(response[0].latitude, response[0].longitude));
          }

          // Set map zoom to fit all markers in map
          if (markers) {
            var bounds = new google.maps.LatLngBounds();
            for (var idx = 0; idx < markers.length; idx++) {
              bounds.extend(markers[idx].getPosition());
            }
            map.fitBounds(bounds);
          }
        }

        $('#total').text(response.length);

        // Stop loading animation.
        $('.infinite-loader').removeClass('active');

        // Call callback.
        if (cb) {
          cb(response);
        }
      },
      error: function(xhr,error) {
        $('.infinite-loader').removeClass('active');
        $('.message').show();
      },
    });
  }

  /**
   * Hide/show resellers in the resellers list baded on the markers visible on the map.
   */
  function filterResellersList() {
    const map_bounds = map.getBounds();
    let reseller_in_bounds = 0;

    markers.forEach(marker => {
      if (map_bounds.contains(marker.getPosition())) {
        reseller_in_bounds += 1;
        $('#reseller-' + marker.reseller_id).show();
      }
      else {
        $('#reseller-' + marker.reseller_id).hide();
      }
    });

    $('#total').text(reseller_in_bounds);
  }

  /**
   * Fetch TC associated to a country/state and display its information above the select.
   *
   * @param string country
   * @param string state
   */
  function fetchAndDisplayTC(country, state) {
    let $result = $('.result-container .commercial .result');

    $.ajax({
      method: 'POST',
      url: mantion.ajaxurl,
      data: {
        action: 'mtn_get_commercial',
        country: country,
        state: state,
      },
      success: function (response) {
        if (response.success) {
          // No result message.
          if (typeof response.data == 'string') {
            $result.html(response.data);
          }
          // Display TC information.
          else {
            let html = "<div><p class='name'>" + response.data.name + "</p>" +
              "<p class='tel'>Tel : " + response.data.phone + "</p>" +
              "<a href='mailto:" + response.data.email + "'>" + response.data.email_pll + "</a></div>";

            if (response.data.picture) {
              html += "<img src='" + response.data.picture + "' alt='' />";
            }

            $result.html(html);
          }
        }
      }
    });
  }

  /**
   * Find a place, recenter map, filter resellers list next to the map + maybe fetch and display
   * the TC associated to the place.
   *
   * @param object request Request params
   * @param boolean getPlaceTC Fetch place associated TC?
   */
  function findPlace(request, getPlaceTC = true) {
    var placesService = new google.maps.places.PlacesService(map);

    placesService.findPlaceFromQuery(request, function (results, status) {
      //console.log(request, status, results[0].geometry.location.toString());
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        // Once map is idle, update the result list based
        // on the current map location and visible area.
        google.maps.event.addListenerOnce(map, 'idle', function() {
            filterResellersList();
        });

        // Update resellers list when zoom changed or user change map position
        map.addListener('bounds_changed', function() {
          filterResellersList();
        });

        // Move map.
        map.setCenter(results[0].geometry.location);

        // Set appropriate map boundaries & zoom.
        if (results[0].geometry.viewport) {
          const bounds = new google.maps.LatLngBounds();
          const boundsData = results[0].geometry.viewport.toJSON();

          bounds.extend(new google.maps.LatLng(
            boundsData.north,
            boundsData.east
          ));
          bounds.extend(new google.maps.LatLng(
            boundsData.south,
            boundsData.west
          ));

          map.fitBounds(bounds);
        }

        if (getPlaceTC) {
          // Try to display the TC associated to the place if any available.
          let detailsRequest = {
            placeId: results[0].place_id,
            fields: ['address_components']
          };

          placesService.getDetails(detailsRequest, function(place, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              var addrComps = new Map();

              place.address_components.forEach(component => {
                addrComps.set(component.types[0], component.short_name);
              });

              if ($('#select_commercial option[value=""]'))
              $('#select_commercial').val(addrComps.get('country'));
            }
          });
        }
      }
    });
  }

  /**
   * Init map with either all resellers or nothing.
   */
  if ($('body').hasClass('page-template-template-revendeurs')) {
    initMap(true, true);
  }
  else {
    initMap();
  }

  /**
   * Handle user's click on the "Locate me" button.
   */
  $('#locateMe').click(function(e) {
    e.preventDefault();

    if (!navigator.geolocation) {
      alert("Sorry, your browser does not support HTML5 geolocation.");
      return;
    }

    // Find user location.
    navigator.geolocation.getCurrentPosition(
      function(position) {
        // Fetch resellers based on user's position + center map on user's position.
        fetchAndDisplayResellers({
          "latitude": position.coords.latitude,
          "longitude": position.coords.longitude,
          "type": "lat_long",
        }, position);
      },
      function (error) {
        if (mantion.geolocalisation.errors[`code_${error.code}`]) {
          alert(mantion.geolocalisation.errors[`code_${error.code}`]);
        }
        else {
          alert(error.message);
        }

        console.warn(`ERROR ${error.code}: ${error.message}`);
      });
  });

  /**
   * Handle country select changes.
   */
  $('#countrySelect').change(function() {
    if ($(this).val() === '') return;

    switch ($(this).val()) {
      // If France, show state select.
      case 'FRANCE':
        $('#stateSelect').show();
        break;

      // Else hide state select and fetch country's resellers.
      default:
        $('#stateSelect').hide();

        fetchAndDisplayResellers({
          "country": $(this).val(),
          "type": "country",
        });
        break;
    }
  });

  /**
   * Handle state select changes.
   */
  $('#stateSelect').change(function() {
    if ($(this).val() === '') return;

    // Search by country + state.
    fetchAndDisplayResellers({
      "country": $('#countrySelect').val(),
      "state": parseInt($(this).val()),
      "type": "state",
    });
  });

  /**
   * Handle search using textual search.
   */
  $('#globalSearch').submit(function(e) {
    e.preventDefault();

    if ($('input[type=text]').val() === '') return;

    // Find searched place.
    fetchAndDisplayResellers({search: '', type: 'no-search'}, null, false, function(response) {
      findPlace({
        "query": $('input[type=text]').val(),
        "fields": ["place_id", "geometry"],
      });
    });
  });

  /**
   * Recenter map when user clicks on a reseller in the resellers list.
   */
  $('body').on('click', '.map--results:not(#results_relay) h3', function() {
    let latitude = parseFloat($(this).attr('data-latitude'));
    let longitude = parseFloat($(this).attr('data-longitude'));

    map.panTo(new google.maps.LatLng(latitude, longitude));
    map.setZoom(13);

    $('html, body').animate({
      scrollTop: $('#map').offset().top - 190
    }, 1000);
  });

  /**
   * Handle TC search with `#select_commercial` select.
   *
   * The select is actually a state select, we must get the TC associated to the state and move
   * the map to the corresponding place.
   */
  $('#select_commercial').on('change', function() {
    // Fetch TC person based on selected state.
    // fetchAndDisplayTC('FR', $(this).val());

    if ($(this).val() === '') {
      fetchAndDisplayResellers({search: '', type: 'no-search'}, null, false);
    }
    else {
      let country = $(this).val();
      fetchAndDisplayResellers({"country": country, "type": "country"});
    }
      /*
    findPlace(
      {
        query: $(this).val(),
        fields: ["place_id", "geometry"],
      },
      false
    );
    */
  });
}

export { gmaps };
